module.exports = __webpack_public_path__ + "static/media/team-1.8af466a4.jpg";